import classNames from 'classnames';

import React, { forwardRef } from 'react';

import { Tab } from './interfaces';
import * as S from './styles';
import { UdTab } from './ud-tab';

interface Props {
  tabs: Tab[];
  beforeChangeTab?: (hash: string) => any;
  className?: string;
  defaultTab: Tab;
  /** Шаблон роута для подсветки активного таба, например `Pages.TEAMS.EDIT`. */
  activeRoutePattern: string;
}

const UDTabs = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { tabs, className, activeRoutePattern } = props;

  return (
    <S.TabsContainer className={classNames('flex flex-row items-center', className)} ref={ref}>
      {tabs.map((tab) => (
        <UdTab key={tab.hash} tab={tab} activeRoutePattern={activeRoutePattern} />
      ))}
    </S.TabsContainer>
  );
});

export default UDTabs;
